var ruRU = {
  locale: 'ru_RU',
  direction: 'ltr',
  date: {
    defaultFormat: {
      week: 'WW/YYYY',
      date: 'DD/MM/YYYY',
      month: 'MM/YYYY',
      year: 'YYYY',
      time: 'HH:mm:ss',
      dateTime: 'DD/MM/YYYY HH:mm:ss'
    },
    startDay: 0,
    shortMonthList: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сеп', 'Окт', 'Ноя', 'Дек'],
    monthList: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сеп', 'Окт', 'Ноя', 'Дек'],
    shortDayList: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    dayList: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    shortestDayList: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
  },
  'dynamic-date': {
    day: 'День',
    week: 'Неделя',
    month: 'Месяц',
    quarter: 'Квартал',
    year: 'Год',
    before: 'До ${value}${unit}'
  },
  'auto-complete.empty': 'Нет данных',
  'select.selected-count': 'Выбрано элементов: ${count}',
  'date-time-picker.date': 'Выберите дату',
  'image-view.zoom-out': 'Уменьшить',
  'input.placeholder': 'Введите',
  'empty.text': 'Нет данных',
  'date-picker.cancel': 'Отмена',
  'date-picker.end': 'Время окончания',
  'cascader.empty': 'Нет данных',
  'upload.drop': 'Перетащите файлы сюда или',
  'color.custom': 'Настройка цвета',
  'cascader.titles': ['Уровень 1', 'Уровень 2', 'Уровень 3', 'Уровень 4', 'Уровень 5', 'Уровень 6', 'Уровень 7', 'Уровень 8'],
  'date-comparison.error-target': 'Выберите время окончания для сравнения',
  'transfer.empty': 'Нет данных',
  'select.search.placeholder': 'Введите',
  'upload.click': 'щелкните, чтобы загрузить',
  'date-time-picker.placeholder': 'Введите',
  'pager.jump': 'Перенаправить',
  'tree-select.placeholder': 'Введите',
  'dynamic-date.interval': 'Интервал',
  'modal.cancel': 'Отмена',
  'image-view.rotate': 'Повернуть',
  'tabs.more': 'Еще',
  'popover.ok': 'Подтвердить',
  'transfer.placeholder': 'Введите',
  'date.month': 'Месяц',
  'select.selected': 'Выбрано',
  'popover.cancel': 'Отмена',
  'image-view.prev': 'Назад',
  'table.emptyText': 'Нет данных',
  'date-time-picker.ok': 'Подтвердить',
  'table.filter.confirm': 'Подтвердить',
  'tree-select.empty': 'Нет данных',
  'dynamic-date.fixed-date': 'Фиксированная дата',
  'date-comparison.compare': 'Сравнить',
  'auto-complete.placeholder': 'Введите',
  'time-picker.placeholder': 'Выберите время',
  'date.month-first': false,
  'select.clear': 'Очистить',
  'date.year': 'Год ${year}',
  'date-comparison.yoy': 'Этот период времени в прошлом году',
  'image-view.zoom-to-origin': 'Оригинал',
  'schedule.title': 'Дата/время',
  'schedule.clear': 'Очистить',
  'date-time-picker.end': 'Выберите дату и время окончания',
  'dynamic-date.customize': 'Настроить',
  'date-picker.apply': 'Применить',
  'schedule.selected': 'Выбранное время',
  'dynamic-date.dynamic-date': 'Динамическая дата',
  'select.placeholder': 'Выберите',
  'schedule.separator': ',',
  'cascader.search': 'Введите',
  'date-picker.invalid-range': 'Выбранный диапазон времени превышает диапазон, доступный для выбора. Укажите действительный диапазон.',
  'dynamic-date.date-preview': 'Предварительный просмотр даты',
  'select.empty': 'Нет данных',
  'image-view.next': 'Далее',
  'date-time-picker.now': 'Сейчас',
  'date-time-picker.time': 'Выбрать время',
  'tree.empty': 'Нет данных',
  'pager.total': 'Всего записей: ${total}',
  'image-view.zoom-in': 'Увеличить',
  'date-picker.placeholder': 'Выберите дату',
  'textarea.placeholder': 'Введите',
  'date.week': 'Неделя',
  'pager.size': '${count} запис./стр.',
  'modal.ok': 'Подтвердить',
  'date-picker.start': 'Время начала',
  'table.filter.reset': 'Сброс',
  'image-view.zoom-to-fit': 'Подогнать',
  'pager.page.placeholder': 'Введите',
  'select.select-all': 'Выбрать все',
  'list-viewer.empty': 'Нет данных',
  'date-comparison.compare-text': 'СРАВНИТЬ',
  'transfer.source': 'Исходный список',
  'date-time-picker.start': 'Выберите дату и время начала',
  'date-time-picker-panel.start': 'Дата начала',
  'date-time-picker-panel.end': 'Дата окончания',
  'date-comparison.error-source': 'Выберите время начала для сравнения',
  'upload.error.overflow-count': 'Максимальное количество файлов превышено',
  'date-comparison.placeholder': 'Время начала - Время окончания',
  'time-range-picker.placeholder': 'Время начала - Время окончания',
  'date-comparison.mom': 'По сравнению с предыдущим периодом времени',
  'transfer.target': 'Целевой список',
  table: {
    selectionMenu: {
      selectCurrent: 'Select Current',
      selectAll: 'Select All',
      unselectCurrent: 'Unselect Current',
      unselectAll: 'Unselect All'
    }
  }
};
export default ruRU;